<template>
  <div class="">

  </div>
</template>

<script>
export default {
  // import Login from '../components/Login'

  name: 'VerifyPage',
  data () {
    return {
      // mode: 'login' // login/register
    }
  },
  props: [],
  components: {

  },
  methods: {

  },
  computed: {

  },
  created () {
    console.log('** Verify Page Loaded', this.$route.path)
    var path = this.$route.path
    var key = path.substr(path.lastIndexOf('/') + 1, path.length)
    this.$store.dispatch('verifyKey', {
      key: key
    })
  }
}
</script>

<style scoped lang="scss">
</style>
